import React from "react"
import PropTypes from "prop-types"
class ScotGraph extends React.Component {
  render () {
    return (
      <div>
        <img src={this.props.img} alt="Scotland Graph" id='opaque-scot'/>

      </div>
    );
  }
}

export default ScotGraph
